module.exports = __webpack_public_path__ + "2221d454f124c37c0381d7dbedc660f2.svg";